// Validated categorical chart palettes (dataviz six-checks: lightness band,
// chroma floor, CVD separation, contrast vs surface — all PASS).
// Assign hues by fixed slot order, never cycled or reshuffled.
export const CHART_COLORS_LIGHT = ['#2563eb', '#059669', '#d97706', '#7c3aed', '#e11d48', '#0891b2'];
export const CHART_COLORS_DARK = ['#3b82f6', '#059669', '#d97706', '#8b5cf6', '#f43f5e', '#0891b2'];

export function isDarkMode(): boolean {
    return document.documentElement.classList.contains('dark');
}

export function chartColor(index: number, dark: boolean): string {
    const palette = dark ? CHART_COLORS_DARK : CHART_COLORS_LIGHT;
    // Fixed order; more than 6 series should be folded into "Other" by the caller
    return palette[index % palette.length];
}

// Status colors (reserved — not for series)
export const STATUS_COLORS = {
    good: '#059669',
    warning: '#d97706',
    serious: '#e11d48',
    neutral: '#6b7280',
};
